/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SelectEventRouteImport } from './routes/select-event'
import { Route as ResultRouteImport } from './routes/result'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

const SelectEventRoute = SelectEventRouteImport.update({
  id: '/select-event',
  path: '/select-event',
  getParentRoute: () => rootRouteImport,
} as any)

const ResultRoute = ResultRouteImport.update({
  id: '/result',
  path: '/result',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/select-event': typeof SelectEventRoute
  '/result': typeof ResultRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/select-event': typeof SelectEventRoute
  '/result': typeof ResultRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '_authenticated': typeof AuthenticatedRoute
  '/': typeof IndexRoute
  '/select-event': typeof SelectEventRoute
  '/result': typeof ResultRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/select-event' | '/result'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/select-event' | '/result'
  id: '__root__' | '_authenticated' | '/' | '/select-event' | '/result'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRoute
  IndexRoute: typeof IndexRoute
  SelectEventRoute: typeof SelectEventRoute
  ResultRoute: typeof ResultRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-event': {
      id: '/select-event'
      path: '/select-event'
      fullPath: '/select-event'
      preLoaderRoute: typeof SelectEventRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/result': {
      id: '/result'
      path: '/result'
      fullPath: '/result'
      preLoaderRoute: typeof ResultRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRoute,
  IndexRoute: IndexRoute,
  SelectEventRoute: SelectEventRoute,
  ResultRoute: ResultRoute,
}

export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
